/* Butterblok theme JS — vanilla, no dependencies, deferred.
   Modules: money, cart, drawer, menu, header, matcher, compare, reveal,
   accordion, pdp, sticky, newsletter, toast. */
(function () {
  'use strict';

  var R = window.BBRoutes || {};
  var CFG = window.BBConfig || {};
  var STR = window.BBStrings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };
  var t = function (k, fb) { return STR[k] || fb || ''; };

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionOff() { return reduced.matches || document.documentElement.classList.contains('bb-no-motion'); }

  /* ---------- country / currency / language pickers ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-bb-locale-select]');
    if (sel && sel.form) sel.form.submit();
  });

  /* ---------- money ---------- */
  function money(cents) {
    /* Prefer the browser's own formatting for the currency the cart is actually
       priced in — with Markets that is the customer's currency, not the shop's,
       and the shop's money format would print the wrong symbol. */
    if (CFG.currency && typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        var out = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: CFG.currency
        }).format(cents / 100);
        return CFG.showCurrencyCode ? out + ' ' + CFG.currency : out;
      } catch (err) { /* fall through to the theme's format string */ }
    }
    var fmt = CFG.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var v = cents / 100, s;
      switch (name) {
        case 'amount': s = fix(v, 2, ',', '.'); break;
        case 'amount_no_decimals': s = fix(v, 0, ',', '.'); break;
        case 'amount_with_comma_separator': s = fix(v, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': s = fix(v, 0, '.', ','); break;
        case 'amount_with_space_separator': s = fix(v, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': s = fix(v, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': s = fix(v, 2, "'", '.'); break;
        default: s = fix(v, 2, ',', '.');
      }
      return s;
    });
  }
  function fix(n, dp, thousands, decimal) {
    var parts = Math.abs(n).toFixed(dp).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (n < 0 ? '-' : '') + int + (parts[1] ? decimal + parts[1] : '');
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, kind) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'bb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' +
      (kind === 'error' ? 'M12 8v5M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z' : 'M20 6 9 17l-5-5') + '"/></svg><span></span>';
    toastEl.lastChild.textContent = msg;
    toastEl.style.background = kind === 'error' ? 'var(--bb-berry)' : 'var(--bb-green)';
    toastEl.setAttribute('data-open', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.setAttribute('data-open', 'false'); }, 3200);
  }

  /* ---------- focus trap ---------- */
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function trap(container, e) {
    var items = $$(SEL, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- cart ---------- */
  var Cart = {
    state: null,
    lastFocus: null,

    fetchState: function () {
      return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.state = c; Cart.render(c); return c; });
    },

    add: function (id, qty, btn) {
      if (btn) btn.setAttribute('data-loading', 'true');
      return fetch(R.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('data-loading');
          if (!res.ok) { toast(res.body.description || res.body.message || t('cartError', 'Something went wrong.'), 'error'); return null; }
          bumpBag();
          return Cart.fetchState().then(function (c) { Drawer.open(); return c; });
        }).catch(function () {
          if (btn) btn.removeAttribute('data-loading');
          toast(t('cartError', 'Something went wrong. Please try again.'), 'error');
        });
    },

    change: function (key, qty, lineEl) {
      var drawer = $('[data-bb-drawer]');
      if (drawer) drawer.setAttribute('data-busy', 'true');
      if (lineEl && qty === 0) lineEl.classList.add('is-removing');
      return fetch(R.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (c) {
          if (drawer) drawer.removeAttribute('data-busy');
          Cart.state = c; Cart.render(c);
          if (document.body.classList.contains('bb-template-cart')) window.location.reload();
          return c;
        }).catch(function () {
          if (drawer) drawer.removeAttribute('data-busy');
          if (lineEl) lineEl.classList.remove('is-removing');
          toast(t('cartError', 'Something went wrong. Please try again.'), 'error');
        });
    },

    render: function (c) {
      $$('[data-bb-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
        el.closest('[data-bb-bag]') && el.closest('[data-bb-bag]').setAttribute('aria-label',
          t('bagLabel', 'Shopping bag') + ', ' + c.item_count + ' ' + (c.item_count === 1 ? t('item', 'item') : t('items', 'items')));
      });
      $$('[data-bb-cart-total]').forEach(function (el) { el.textContent = money(c.total_price); });

      var body = $('[data-bb-cart-lines]');
      if (!body) return;
      var foot = $('[data-bb-cart-foot]');
      var reassure = $('[data-bb-cart-reassure]');

      if (!c.item_count) {
        body.innerHTML = emptyMarkup();
        if (foot) foot.hidden = true;
        if (reassure) reassure.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      if (reassure) reassure.hidden = false;
      body.innerHTML = c.items.map(lineMarkup).join('');
    }
  };

  function emptyMarkup() {
    return '<div class="bb-empty">' +
      '<div class="bb-empty__blob" aria-hidden="true"><svg viewBox="0 0 100 100"><path fill="currentColor" d="M50 6c18 0 32 8 38 22 7 15 3 33-8 45-10 11-25 17-38 14C27 84 13 72 8 57 3 41 8 24 21 14 29 9 39 6 50 6Z"/></svg></div>' +
      '<h3>' + t('emptyTitle', 'Your bag is feeling light.') + '</h3>' +
      '<p>' + t('emptyBody', 'Choose a spread and give every travel essential a happy little home.') + '</p>' +
      '<p><button type="button" class="bb-btn bb-btn--primary" data-bb-shop>' + t('emptyCta', 'Start packing') + '</button></p>' +
      '</div>';
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }

  function lineMarkup(item) {
    var img = item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') : '';
    var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.value); }).join(' · ');
    var sale = item.original_line_price > item.final_line_price;
    return '<div class="bb-line" data-bb-line data-key="' + esc(item.key) + '">' +
      '<div class="bb-line__media">' + (img ? '<img src="' + esc(img) + '" alt="" width="200" height="200" loading="lazy">' : '') + '</div>' +
      '<div>' +
      '<a class="bb-line__name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
      (opts ? '<p class="bb-line__opt">' + opts + '</p>' : '<p class="bb-line__opt"></p>') +
      '<div class="bb-line__row">' +
      '<div class="bb-qty">' +
      '<button type="button" data-bb-qty="-1" aria-label="' + t('decrease', 'Decrease quantity') + '"' + (item.quantity <= 1 ? '' : '') + '><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><rect x="1" y="5" width="10" height="2" rx="1" fill="currentColor"/></svg></button>' +
      '<input type="number" min="0" step="1" value="' + item.quantity + '" data-bb-qty-input aria-label="' + t('quantity', 'Quantity') + '">' +
      '<button type="button" data-bb-qty="1" aria-label="' + t('increase', 'Increase quantity') + '"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M5 1h2v10H5z" fill="currentColor"/><path d="M1 5h10v2H1z" fill="currentColor"/></svg></button>' +
      '</div>' +
      '<span class="bb-line__price">' + (sale ? '<s>' + money(item.original_line_price) + '</s> ' : '') + money(item.final_line_price) + '</span>' +
      '</div>' +
      '<button type="button" class="bb-line__remove" data-bb-remove>' + t('remove', 'Remove') + '</button>' +
      '</div></div>';
  }

  function bumpBag() {
    $$('[data-bb-bag]').forEach(function (b) {
      if (motionOff()) return;
      b.classList.remove('is-bumped');
      void b.offsetWidth;
      b.classList.add('is-bumped');
    });
  }

  /* ---------- drawer ---------- */
  var Drawer = {
    open: function () {
      var d = $('[data-bb-drawer]'), o = $('[data-bb-overlay]');
      if (!d) return;
      Cart.lastFocus = document.activeElement;
      d.setAttribute('data-open', 'true');
      d.setAttribute('aria-hidden', 'false');
      if (o) o.setAttribute('data-open', 'true');
      document.body.classList.add('bb-no-scroll');
      var close = $('[data-bb-drawer-close]', d);
      if (close) close.focus();
    },
    close: function () {
      var d = $('[data-bb-drawer]'), o = $('[data-bb-overlay]');
      if (!d) return;
      d.setAttribute('data-open', 'false');
      d.setAttribute('aria-hidden', 'true');
      if (o) o.setAttribute('data-open', 'false');
      document.body.classList.remove('bb-no-scroll');
      if (Cart.lastFocus && Cart.lastFocus.focus) Cart.lastFocus.focus();
    }
  };

  /* ---------- mobile menu ---------- */
  var Menu = {
    lastFocus: null,
    toggle: function (force) {
      var m = $('[data-bb-menu]');
      if (!m) return;
      var open = force != null ? force : m.getAttribute('data-open') !== 'true';
      m.setAttribute('data-open', open ? 'true' : 'false');
      m.setAttribute('aria-hidden', open ? 'false' : 'true');
      /* more than one control opens this drawer — the burger and the currency
         pill — so every one of them has to report the same state */
      $$('[data-bb-burger],[data-bb-locale-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.body.classList.toggle('bb-no-scroll', open);
      if (open) { Menu.lastFocus = document.activeElement; var f = $(SEL, m); f && f.focus(); }
      else if (Menu.lastFocus) Menu.lastFocus.focus();
    }
  };

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-bb-add]'))) {
      e.preventDefault();
      var id = el.getAttribute('data-variant-id');
      if (!id) { toast(t('selectOption', 'Please choose an option first.'), 'error'); return; }
      Cart.add(id, Number(el.getAttribute('data-qty') || 1), el);
      return;
    }
    if ((el = e.target.closest('[data-bb-bag]'))) { e.preventDefault(); Drawer.open(); return; }
    if (e.target.closest('[data-bb-drawer-close]') || e.target.closest('[data-bb-overlay]')) { Drawer.close(); return; }
    if ((el = e.target.closest('[data-bb-shop]'))) {
      Drawer.close();
      var target = document.getElementById(CFG.shopAnchor || 'shop');
      if (target) { target.scrollIntoView({ behavior: motionOff() ? 'auto' : 'smooth', block: 'start' }); }
      else window.location.href = R.root;
      return;
    }
    if ((el = e.target.closest('[data-bb-burger]'))) { e.preventDefault(); Menu.toggle(); return; }
    /* the currency pill opens the same drawer, then puts the cursor straight on
       the country select so the thing it promised is the thing in focus */
    if ((el = e.target.closest('[data-bb-locale-open]'))) {
      e.preventDefault();
      Menu.toggle(true);
      var cs = document.querySelector('[data-bb-menu] select[name="country_code"]');
      if (cs) setTimeout(function () { try { cs.focus(); } catch (err) {} }, 260);
      return;
    }
    if ((el = e.target.closest('[data-bb-menu-close]'))) { Menu.toggle(false); return; }
    if (e.target.closest('[data-bb-menu] a')) { Menu.toggle(false); return; }

    /* product page quantity */
    if ((el = e.target.closest('[data-bb-pdp-qty]'))) {
      var qi = document.getElementById('bb-pdp-qty');
      if (qi) {
        var nq = Math.max(1, (parseInt(qi.value, 10) || 1) + Number(el.getAttribute('data-bb-pdp-qty')));
        qi.value = nq;
        $$('[data-bb-add]').forEach(function (b) { if (b.closest('[data-bb-product="main"]')) b.setAttribute('data-qty', nq); });
      }
      return;
    }

    /* quantity + / - */
    if ((el = e.target.closest('[data-bb-qty]'))) {
      var line = el.closest('[data-bb-line]');
      var input = $('[data-bb-qty-input]', el.parentNode);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + Number(el.getAttribute('data-bb-qty')));
      input.value = next;
      if (line) Cart.change(line.getAttribute('data-key'), next, line);
      return;
    }
    if ((el = e.target.closest('[data-bb-remove]'))) {
      var l = el.closest('[data-bb-line]');
      if (l) Cart.change(l.getAttribute('data-key'), 0, l);
      return;
    }

    /* colour swatch */
    if ((el = e.target.closest('[data-bb-swatch]'))) {
      e.preventDefault();
      selectVariant(el);
      return;
    }

    /* packing matcher */
    if ((el = e.target.closest('[data-bb-match]'))) {
      var want = el.getAttribute('data-bb-match');
      $$('[data-bb-match]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      var live = $('[data-bb-match-live]');
      $$('[data-bb-card]').forEach(function (card) {
        var hit = card.getAttribute('data-bb-handle') === want || card.getAttribute('data-bb-key') === want;
        card.classList.toggle('is-matched', hit);
        if (hit) {
          if (live) live.textContent = t('matchLive', 'Recommended:') + ' ' + (card.getAttribute('data-bb-title') || '');
          card.scrollIntoView({ behavior: motionOff() ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
      return;
    }

    /* accordion */
    if ((el = e.target.closest('[data-bb-acc-btn]'))) {
      var expanded = el.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(el.getAttribute('aria-controls'));
      el.setAttribute('aria-expanded', String(!expanded));
      if (panel) {
        if (expanded) {
          panel.style.height = panel.scrollHeight + 'px'; void panel.offsetHeight;
          panel.style.height = '0px'; panel.classList.remove('is-open');
        } else {
          panel.classList.add('is-open');
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function h() { panel.style.height = 'auto'; panel.removeEventListener('transitionend', h); });
        }
      }
      return;
    }

    /* pdp thumbnails */
    if ((el = e.target.closest('[data-bb-thumb]'))) {
      showThumb(el);
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var el;
    if (e.target.id === 'bb-pdp-qty') {
      var q = Math.max(1, parseInt(e.target.value, 10) || 1);
      e.target.value = q;
      $$('[data-bb-add]').forEach(function (b) { if (b.closest('[data-bb-product="main"]')) b.setAttribute('data-qty', q); });
      return;
    }
    if ((el = e.target.closest('[data-bb-qty-input]'))) {
      var line = el.closest('[data-bb-line]');
      var v = Math.max(0, parseInt(el.value, 10) || 0);
      el.value = v;
      if (line) Cart.change(line.getAttribute('data-key'), v, line);
      return;
    }
    if ((el = e.target.closest('[data-bb-variant-select]'))) { syncVariant(el.closest('[data-bb-product]'), el.value); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = $('[data-bb-drawer]');
      if (d && d.getAttribute('data-open') === 'true') { Drawer.close(); return; }
      var m = $('[data-bb-menu]');
      if (m && m.getAttribute('data-open') === 'true') { Menu.toggle(false); return; }
    }
    if (e.key === 'Tab') {
      var d2 = $('[data-bb-drawer]');
      if (d2 && d2.getAttribute('data-open') === 'true') { trap(d2, e); return; }
      var m2 = $('[data-bb-menu]');
      if (m2 && m2.getAttribute('data-open') === 'true') { trap(m2, e); }
    }
  });

  /* ---------- variant selection ---------- */
  /* One thumbnail becomes the big picture. Pulled out of the click handler so
     the colour filter can call it too. */
  function showThumb(btn) {
    if (!btn) return;
    var main = $('[data-bb-pdp-main] img');
    if (main) {
      main.src = btn.getAttribute('data-src');
      if (btn.getAttribute('data-srcset')) main.srcset = btn.getAttribute('data-srcset');
      else main.removeAttribute('srcset');
      main.alt = btn.getAttribute('data-alt') || main.alt;
    }
    $$('[data-bb-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === btn)); });
  }

  /* Choosing Forest Green should not leave you scrolling past yellow photos.
     Thumbnails carry the colour they show; anything with no colour on it (a
     detail shot, a size chart) stays visible for every colour. If a filter
     would empty the gallery the filter is abandoned rather than the pictures. */
  function filterGalleryByColour(colour) {
    var thumbs = $$('[data-bb-thumb]');
    if (!thumbs.length) return;
    var norm = function (s) { return (s || '').trim().toLowerCase(); };
    var want = norm(colour);
    var visible = [], matching = [];
    thumbs.forEach(function (t) {
      var c = norm(t.getAttribute('data-colour'));
      var show = !c || !want || c === want;
      t.hidden = !show;
      if (show) visible.push(t);
      if (c && want && c === want) matching.push(t);
    });
    if (!visible.length) {
      thumbs.forEach(function (t) { t.hidden = false; });
      visible = thumbs;
    }
    var main = $('[data-bb-pdp-main] img');
    var src = main ? main.getAttribute('src') : null;
    var current = null;
    visible.forEach(function (t) {
      if (src && t.getAttribute('data-src') === src) current = t;
    });
    /* If any photograph is explicitly this colour and the one on screen is not
       one of them, move to it. Without this, a picture that names no colour —
       or a variant with no image of its own — left the previous colour's
       photograph on screen and the swatch appeared to do nothing. */
    if (matching.length && matching.indexOf(current) === -1) {
      showThumb(matching[0]);
    } else if (current) {
      thumbs.forEach(function (b) { b.setAttribute('aria-current', String(b === current)); });
    } else {
      showThumb(visible[0]);
    }
  }

  function selectVariant(btn) {
    var root = btn.closest('[data-bb-product]') || btn.closest('[data-bb-card]');
    if (!root) return;
    syncVariant(root, btn.getAttribute('data-variant-id'));
  }

  function syncVariant(root, variantId) {
    if (!root || !variantId) return;
    var data = root.querySelector('[data-bb-variants]');
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
    if (!v) return;

    $$('[data-bb-swatch]', root).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-variant-id') === String(variantId)));
    });
    var sel = $('[data-bb-variant-select]', root);
    if (sel && sel.value !== String(variantId)) sel.value = String(variantId);
    var hidden = $('[data-bb-form-variant]', root);
    if (hidden) hidden.value = String(variantId);
    var cname = $('[data-bb-colour-name]', root);
    if (cname) {
      var pressed = $('[data-bb-swatch][aria-pressed="true"]', root);
      if (pressed) cname.textContent = pressed.getAttribute('data-colour-value') || '';
    }

    /* image morph */
    var img = $('[data-bb-variant-image]', root) || $('[data-bb-pdp-main] img', root) || $('.bb-card__media img', root);
    if (img && v.image) {
      if (motionOff()) { img.src = v.image; if (v.srcset) img.srcset = v.srcset; }
      else {
        img.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          img.src = v.image;
          if (v.srcset) img.srcset = v.srcset; else img.removeAttribute('srcset');
          img.alt = v.alt || img.alt;
          requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
        };
        pre.src = v.image;
      }
    }
    if (root.getAttribute('data-bb-product') === 'main') filterGalleryByColour(v.colour || '');

    /* price + availability */
    $$('[data-bb-variant-price]', root).forEach(function (el) {
      el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s> ' : '') + money(v.price);
    });
    $$('[data-bb-add]', root).forEach(function (b) {
      b.setAttribute('data-variant-id', v.id);
      b.disabled = !v.available;
      var label = $('[data-bb-add-label]', b);
      if (label) label.textContent = v.available ? t('addToBag', 'Add to bag') : t('soldOut', 'Sold out');
    });
    /* keep url in sync on product pages only */
    if (root.getAttribute('data-bb-product') === 'main' && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    }
    var sticky = $('[data-bb-sticky]');
    if (sticky) {
      var sc = $('[data-bb-sticky-colour]', sticky);
      if (sc && v.colour) sc.textContent = v.colour;
      var sp = $('[data-bb-sticky-price]', sticky);
      if (sp) sp.textContent = money(v.price);
    }
  }

  /* ---------- header stuck state ---------- */
  (function () {
    var header = $('[data-bb-header]');
    if (!header) return;
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(sentinel);
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      header.setAttribute('data-stuck', String(!entries[0].isIntersecting));
    }).observe(sentinel);
  })();

  /* ---------- scroll reveal ---------- */
  (function () {
    var items = $$('[data-bb-reveal]');
    if (!items.length) return;
    if (motionOff() || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- before / after compare ---------- */
  $$('[data-bb-compare]').forEach(function (root) {
    var range = $('[data-bb-compare-range]', root);
    if (!range) return;
    function set(v) { root.style.setProperty('--bb-split', v + '%'); range.setAttribute('aria-valuetext', Math.round(v) + '% ' + t('compressed', 'compressed view')); }
    on(range, 'input', function () { set(range.value); });
    set(range.value);
    /* gentle auto-hint once in view */
    if (!motionOff() && 'IntersectionObserver' in window) {
      var done = false;
      new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting || done) return;
        done = true; obs.disconnect();
        var start = performance.now(), from = Number(range.value), to = 72, dur = 900;
        (function step(now) {
          var p = Math.min(1, (now - start) / dur);
          var e2 = 1 - Math.pow(1 - p, 3);
          range.value = from + (to - from) * e2; set(range.value);
          if (p < 1) requestAnimationFrame(step);
        })(start);
      }, { threshold: 0.4 }).observe(root);
    }
  });

  /* ---------- sticky buy bar ---------- */
  (function () {
    var bar = $('[data-bb-sticky]');
    var anchor = $('[data-bb-buy-anchor]');
    if (!bar || !anchor) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      /* Show only once the real buy button has scrolled above the viewport,
         and hide again near the very bottom so it never covers the footer. */
      var scrolledPast = r.bottom < 0;
      var nearBottom = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 220);
      bar.setAttribute('data-open', String(scrolledPast && !nearBottom));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  /* ---------- fold long copy ---------- */
  (function () {
    $$('[data-bb-clamp]').forEach(function (box) {
      var inner = $('.bb-clamp__inner', box);
      var btn = $('[data-bb-clamp-more]', box);
      if (!inner || !btn) return;
      var lines = parseInt(box.getAttribute('data-lines'), 10) || 4;
      box.style.setProperty('--bb-clamp-lines', lines);
      box.setAttribute('data-open', 'false');
      /* only offer Read more when there is genuinely more to read */
      requestAnimationFrame(function () {
        if (inner.scrollHeight <= inner.clientHeight + 4) {
          box.setAttribute('data-open', 'true');
          return;
        }
        btn.hidden = false;
      });
      btn.addEventListener('click', function () {
        var open = box.getAttribute('data-open') === 'true';
        box.setAttribute('data-open', String(!open));
        var label = $('span', btn);
        if (label) label.textContent = open ? t('readMore', 'Read more') : t('readLess', 'Show less');
      });
    });
  })();

  /* ---------- hero photo carousel ---------- */
  (function () {
    var show = $('[data-bb-heroshow]');
    if (!show) return;
    var track = $('[data-bb-heroshow-track]', show);
    var dotsBox = $('[data-bb-heroshow-dots]', show);
    var slides = $$('[data-bb-heroshow-slide]', show);
    if (!track || slides.length < 2) return;

    var dots = [];
    if (dotsBox) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bb-heroshow__dot';
        d.setAttribute('data-bb-heroshow-dot', '');
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', String(i + 1));
        d.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        d.addEventListener('click', function () { stop(); go(i); });
        dotsBox.appendChild(d);
        dots.push(d);
      });
    }

    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: motionOff() ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = current();
      dots.forEach(function (d, n) { d.setAttribute('aria-selected', String(n === i)); });
    }
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(mark, 90);
    }, { passive: true });

    var timer = null;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (motionOff()) return;
      if (show.getAttribute('data-autoplay') !== 'true') return;
      var wait = (parseFloat(show.getAttribute('data-interval')) || 5) * 1000;
      stop();
      timer = setInterval(function () {
        if (document.hidden) return;
        go((current() + 1) % slides.length);
      }, wait);
    }
    /* any deliberate input hands control to the visitor for good */
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, stop, { passive: true, once: true });
    });
    show.addEventListener('mouseenter', stop);
    start();
  })();

  /* ---------- the hero photograph follows the colour choice ---------- */
  (function () {
    var shot = $('[data-bb-hero-shot]');
    var slides = $$('[data-bb-heroshow-slide]');
    if (!shot && !slides.length) return;
    var img = shot && shot.querySelector('img');
    if (img) img.setAttribute('data-bb-hero-img', '');
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-bb-swatch]');
      if (!sw || sw.disabled) return;
      var value = (sw.getAttribute('data-colour-value') || '').toLowerCase();
      var key = value.indexOf('green') > -1 ? 'data-green' : 'data-yellow';
      var targets = shot ? [shot] : slides;
      targets.forEach(function (box) {
        var pic = box.querySelector('img');
        var src = box.getAttribute(key);
        if (!pic || !src || pic.getAttribute('src') === src) return;
        var pre = new Image();
        /* Only paint the twin once it has actually loaded. Firing on error too
           meant a colour twin that was never shipped replaced the photograph
           with a broken image, and stripped the srcset on the way out so the
           slide could not recover. */
        pre.onload = function () { pic.removeAttribute('srcset'); pic.src = src; };
        pre.onerror = function () {};
        pre.src = src;
      });
    }, true);
  })();

  /* ---------- phone shortcut bar to the spreads ---------- */
  (function () {
    var bar = $('[data-bb-shopbar]');
    /* Anchor on the first real Add to bag button, not the panel — the shortcut
       is worth showing for exactly as long as buying is still out of reach. */
    var shop = document.querySelector('.bb-shop__grid [data-bb-add]') || document.getElementById('shop');
    if (!bar || !shop) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = shop.getBoundingClientRect();
      /* Open once the visitor has started scrolling and the spreads are still
         below the fold; closed the moment they arrive. Waiting for that first
         scroll keeps the bar off the hero when the page has only just loaded. */
      var started = window.scrollY > window.innerHeight * 0.25;
      var below = started && r.top > window.innerHeight - 60;
      bar.setAttribute('data-open', String(below));
      bar.setAttribute('aria-hidden', String(!below));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  /* ---------- newsletter inline feedback ---------- */
  $$('[data-bb-newsletter]').forEach(function (form) {
    on(form, 'submit', function () {
      var b = $('button[type="submit"]', form);
      if (b) b.setAttribute('data-loading', 'true');
    });
  });


  /* ---------- click-to-load video embeds ----------
     Nothing is requested from YouTube or Vimeo until someone presses play, so a
     page carrying three videos still loads like a page carrying three images. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bb-embed-play]');
    if (!btn) return;
    var box = btn.closest('[data-bb-embed]');
    if (!box) return;
    var id = box.getAttribute('data-bb-embed');
    var type = (box.getAttribute('data-bb-embed-type') || '').toLowerCase();
    if (!id) return;
    var src = type === 'vimeo'
      ? 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&title=0&byline=0'
      : 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    var f = document.createElement('iframe');
    f.setAttribute('src', src);
    f.setAttribute('title', btn.getAttribute('aria-label') || 'Video');
    f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; picture-in-picture');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('loading', 'lazy');
    box.innerHTML = '';
    box.appendChild(f);
    f.focus();
  });

  /* ---------- boot ---------- */
  function boot() {
    if (motionOff()) document.documentElement.classList.add('bb-no-motion');
    Cart.fetchState().catch(function () { });
    var initial = $('[data-bb-product="main"]');
    if (initial) {
      /* The page arrives showing every photograph. Narrow it to the colour the
         visitor actually landed on, so the gallery is right before they touch
         anything. */
      var pre = $('[data-bb-swatch][aria-pressed="true"]', initial);
      var startColour = pre ? (pre.getAttribute('data-colour-value') || '') : '';
      if (!startColour) {
        var hidden = $('[data-bb-form-variant]', initial) || $('[data-bb-variant-select]', initial);
        var data = $('[data-bb-variants]', initial);
        if (hidden && data) {
          try {
            var list = JSON.parse(data.textContent);
            var match = list.filter(function (x) { return String(x.id) === String(hidden.value); })[0];
            if (match) startColour = match.colour || '';
          } catch (err) { startColour = ''; }
        }
      }
      if (startColour) filterGalleryByColour(startColour);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function () { Cart.fetchState().catch(function () { }); $$('[data-bb-reveal]').forEach(function (el) { el.classList.add('is-in'); }); });

  window.Butterblok = { Cart: Cart, Drawer: Drawer, Menu: Menu, money: money, toast: toast };
})();

/* ============================================================
   Butterblok motion layer.
   Runs after the core module above and talks to it via window.Butterblok.
   Every effect checks reduced motion and degrades to a static, usable state.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || { passive: true }); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function still() { return reduced.matches || document.documentElement.classList.contains('bb-no-motion'); }
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var BB = window.Butterblok || {};
  var CFG = window.BBConfig || {};
  var allow = function (key) { return CFG[key] !== false; };

  /* ---------- one shared scroll loop ---------- */
  var scrollJobs = [], rafJobs = [], ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var vh = window.innerHeight;
      for (var i = 0; i < scrollJobs.length; i++) scrollJobs[i](y, vh);
    });
  }
  on(window, 'scroll', onScroll);
  on(window, 'resize', onScroll);

  /* continuous loop only while something needs it (magnetic, tilt, eyes) */
  var loopOn = false;
  function startLoop() {
    if (loopOn || !rafJobs.length) return;
    loopOn = true;
    (function tick() {
      for (var i = 0; i < rafJobs.length; i++) rafJobs[i]();
      requestAnimationFrame(tick);
    })();
  }

  /* ---------- 1. scroll progress ---------- */
  (function () {
    var bar = $('[data-bb-progress]');
    if (!bar) return;
    scrollJobs.push(function (y) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--bb-scroll', max > 0 ? (y / max).toFixed(4) : 0);
    });
  })();

  /* ---------- 2. parallax ---------- */
  (function () {
    var items = $$('[data-bb-parallax]');
    if (!items.length || still()) return;
    scrollJobs.push(function (y, vh) {
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue;
        var speed = parseFloat(el.getAttribute('data-bb-parallax')) || 0.12;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.setProperty('--bb-py', (-mid * speed).toFixed(2));
      }
    });
    onScroll();
  })();

  /* ---------- 3. count up ---------- */
  (function () {
    var nums = $$('[data-bb-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var raw = el.getAttribute('data-bb-count') || el.textContent;
        var m = String(raw).match(/^(\D*)([\d.,]+)(.*)$/);
        if (!m || still()) { el.textContent = raw; return; }
        var pre = m[1], target = parseFloat(m[2].replace(/,/g, '')), post = m[3];
        var dp = (m[2].split('.')[1] || '').length;
        var start = performance.now(), dur = 1500;
        (function step(now) {
          var p = clamp((now - start) / dur, 0, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = pre + (target * e).toFixed(dp) + post;
          if (p < 1) requestAnimationFrame(step);
        })(start);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  })();

  /* ---------- 4. marquee (duplicate the group so the loop is seamless) ---------- */
  $$('[data-bb-marquee]').forEach(function (track) {
    var group = $('.bb-marquee__group', track);
    if (!group) return;
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  /* ---------- 5. split text: headline words + butter letters ---------- */
  function splitWords(el) {
    if (el.dataset.bbSplit) return;
    el.dataset.bbSplit = '1';
    var text = el.textContent;
    el.setAttribute('aria-label', text);
    var frag = document.createDocumentFragment(), i = 0;
    text.split(/(\s+)/).forEach(function (part) {
      if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
      var w = document.createElement('span');
      w.className = 'bb-word';
      var inner = document.createElement('span');
      inner.textContent = part;
      inner.style.setProperty('--i', i++);
      w.appendChild(inner);
      w.setAttribute('aria-hidden', 'true');
      frag.appendChild(w);
    });
    el.textContent = '';
    el.appendChild(frag);
  }
  $$('[data-bb-words]').forEach(function (el) {
    splitWords(el);
    if (still() || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    new IntersectionObserver(function (e, o) {
      if (e[0].isIntersecting) { el.classList.add('is-in'); o.disconnect(); }
    }, { threshold: 0.2 }).observe(el);
  });

  $$('[data-bb-butter]').forEach(function (el) {
    if (el.dataset.bbSplit || still()) return;
    el.dataset.bbSplit = '1';
    var text = el.textContent;
    el.setAttribute('aria-label', text);
    var frag = document.createDocumentFragment();
    text.split('').forEach(function (ch) {
      if (ch === ' ') { frag.appendChild(document.createTextNode(' ')); return; }
      var c = document.createElement('span');
      c.className = 'bb-ch';
      c.textContent = ch;
      c.setAttribute('aria-hidden', 'true');
      frag.appendChild(c);
    });
    el.textContent = '';
    el.appendChild(frag);
  });

  /* ---------- 6. magnetic buttons ---------- */
  (function () {
    if (still() || !window.matchMedia('(hover:hover)').matches) return;
    $$('[data-bb-magnet]').forEach(function (el) {
      var tx = 0, ty = 0, cx = 0, cy = 0, active = false;
      on(el, 'pointerenter', function () { active = true; });
      on(el, 'pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var str = parseFloat(el.getAttribute('data-bb-magnet')) || 0.3;
        tx = (e.clientX - (r.left + r.width / 2)) * str;
        ty = (e.clientY - (r.top + r.height / 2)) * str;
      });
      on(el, 'pointerleave', function () { active = false; tx = 0; ty = 0; });
      rafJobs.push(function () {
        if (!active && Math.abs(cx) < 0.05 && Math.abs(cy) < 0.05) return;
        cx = lerp(cx, tx, 0.18); cy = lerp(cy, ty, 0.18);
        el.style.setProperty('--bb-mx', cx.toFixed(2));
        el.style.setProperty('--bb-my', cy.toFixed(2));
      });
    });
    startLoop();
  })();

  /* ---------- 7. mascot: eyes follow the cursor, and blink ---------- */
  (function () {
    var mascots = $$('[data-bb-mascot]');
    if (!mascots.length) return;
    if (!still() && window.matchMedia('(hover:hover)').matches) {
      var mx = 0, my = 0;
      on(window, 'pointermove', function (e) { mx = e.clientX; my = e.clientY; });
      rafJobs.push(function () {
        mascots.forEach(function (m) {
          var r = m.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var dx = clamp((mx - (r.left + r.width / 2)) / 90, -3.2, 3.2);
          var dy = clamp((my - (r.top + r.height / 2)) / 90, -2.6, 2.6);
          m.style.setProperty('--bb-ex', dx.toFixed(2));
          m.style.setProperty('--bb-ey', dy.toFixed(2));
        });
      });
      startLoop();
    }
    if (still()) return;
    (function blink() {
      var m = mascots[Math.floor(Math.random() * mascots.length)];
      if (m) {
        m.setAttribute('data-blink', 'true');
        setTimeout(function () { m.removeAttribute('data-blink'); }, 130);
      }
      setTimeout(blink, 2200 + Math.random() * 3600);
    })();
  })();

  /* ---------- 8. 3D tilt ---------- */
  (function () {
    if (still() || !window.matchMedia('(hover:hover)').matches) return;
    $$('[data-bb-tilt]').forEach(function (el) {
      var inner = $('.bb-tilt__inner', el) || el.firstElementChild;
      if (!inner) return;
      var max = parseFloat(el.getAttribute('data-bb-tilt')) || 9;
      on(el, 'pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        inner.style.setProperty('--bb-ty', (px * max * 2).toFixed(2));
        inner.style.setProperty('--bb-tx', (-py * max * 2).toFixed(2));
      });
      on(el, 'pointerleave', function () {
        inner.style.setProperty('--bb-ty', 0);
        inner.style.setProperty('--bb-tx', 0);
      });
    });
  })();

  /* ---------- 9. fly to bag + confetti ---------- */
  var CUBE_SVG = '<svg viewBox="0 0 64 52" aria-hidden="true"><rect x="3" y="8" width="58" height="40" rx="11" fill="currentColor"/><rect x="3" y="8" width="58" height="11" rx="5.5" fill="rgba(0,0,0,.09)"/><rect x="14" y="26" width="36" height="14" rx="6" fill="rgba(255,255,255,.5)"/><path d="M24 8c0-4 4-6 8-6s8 2 8 6" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/></svg>';

  function flyToBag(fromEl, colour) {
    if (still()) return;
    var bag = $('[data-bb-bag-btn]') || $('[data-bb-bag]');
    if (!bag || !fromEl) return;
    var a = fromEl.getBoundingClientRect(), b = bag.getBoundingClientRect();
    var fly = document.createElement('div');
    fly.className = 'bb-fly';
    fly.innerHTML = CUBE_SVG;
    if (colour) fly.style.color = colour;
    document.body.appendChild(fly);
    var x0 = a.left + a.width / 2 - 32, y0 = a.top + a.height / 2 - 26;
    var x1 = b.left + b.width / 2 - 32, y1 = b.top + b.height / 2 - 26;
    var arc = Math.min(220, Math.abs(y1 - y0) * 0.6 + 90);
    var start = performance.now(), dur = 720;
    (function step(now) {
      var p = clamp((now - start) / dur, 0, 1);
      var e = p * p * (3 - 2 * p);
      var x = lerp(x0, x1, e);
      var y = lerp(y0, y1, e) - Math.sin(e * Math.PI) * arc;
      var sc = lerp(1, 0.28, e);
      fly.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + sc + ') rotate(' + (e * 320) + 'deg)';
      fly.style.opacity = p > 0.86 ? String(1 - (p - 0.86) / 0.14) : '1';
      if (p < 1) requestAnimationFrame(step); else fly.remove();
    })(start);
  }

  /* fly any node from one place to another — used by the patch picker */
  function flyTo(fromEl, toEl, node, opts) {
    if (still() || !fromEl || !toEl || !node) return;
    var a = fromEl.getBoundingClientRect(), b = toEl.getBoundingClientRect();
    var o = opts || {};
    node.style.cssText = 'position:fixed;left:0;top:0;z-index:120;pointer-events:none;will-change:transform';
    document.body.appendChild(node);
    var w = node.offsetWidth || 40, h = node.offsetHeight || 40;
    var x0 = a.left + a.width / 2 - w / 2, y0 = a.top + a.height / 2 - h / 2;
    var x1 = b.left + b.width / 2 - w / 2, y1 = b.top + b.height / 2 - h / 2;
    var arc = o.arc == null ? Math.min(150, Math.abs(y1 - y0) * 0.4 + 50) : o.arc;
    var start = performance.now(), dur = o.duration || 560;
    (function step(now) {
      var p = clamp((now - start) / dur, 0, 1);
      var e = p * p * (3 - 2 * p);
      var x = lerp(x0, x1, e), y = lerp(y0, y1, e) - Math.sin(e * Math.PI) * arc;
      var sc = lerp(1, o.endScale == null ? 1.05 : o.endScale, e);
      node.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + sc + ') rotate(' + (e * (o.spin == null ? 220 : o.spin)) + 'deg)';
      node.style.opacity = p > 0.9 ? String(1 - (p - 0.9) / 0.1) : '1';
      if (p < 1) requestAnimationFrame(step);
      else { node.remove(); if (o.onLand) o.onLand(); }
    })(start);
  }

  function confetti(originEl) {
    if (still()) return;
    var host = document.createElement('div');
    host.className = 'bb-confetti';
    document.body.appendChild(host);
    var r = originEl ? originEl.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    var cs = getComputedStyle(document.documentElement);
    var cols = [cs.getPropertyValue('--bb-yellow'), cs.getPropertyValue('--bb-green'), cs.getPropertyValue('--bb-brown'), cs.getPropertyValue('--bb-blush')];
    var bits = [];
    for (var i = 0; i < 26; i++) {
      var b = document.createElement('i');
      b.style.setProperty('--c', (cols[i % cols.length] || '#FFCE1B').trim());
      host.appendChild(b);
      var ang = (-Math.PI / 2) + (Math.random() - 0.5) * 2.1;
      var sp = 6 + Math.random() * 10;
      bits.push({ el: b, x: ox, y: oy, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp - 4, rot: Math.random() * 360, vr: (Math.random() - 0.5) * 24 });
    }
    var t0 = performance.now();
    (function step(now) {
      var dt = Math.min(32, now - t0); t0 = now;
      var alive = false;
      bits.forEach(function (p) {
        p.vy += 0.55 * (dt / 16);
        p.x += p.vx * (dt / 16); p.y += p.vy * (dt / 16); p.rot += p.vr * (dt / 16);
        if (p.y < innerHeight + 60) alive = true;
        p.el.style.transform = 'translate3d(' + p.x + 'px,' + p.y + 'px,0) rotate(' + p.rot + 'deg)';
      });
      if (alive) requestAnimationFrame(step); else host.remove();
    })(t0);
  }

  document.addEventListener('click', function (e) {
    if (!allow('confetti')) return;
    var add = e.target.closest('[data-bb-add]');
    if (add && !add.disabled) {
      var card = add.closest('[data-bb-card]') || add.closest('[data-bb-product]');
      var img = card && (card.querySelector('.bb-card__media img') || card.querySelector('[data-bb-pdp-main] img'));
      var swatch = card && card.querySelector('[data-bb-swatch][aria-pressed="true"] i');
      var colour = swatch ? getComputedStyle(swatch).backgroundColor : null;
      flyToBag(img || add, colour);
      setTimeout(function () { confetti(add); }, 620);
    }
  }, true);

  /* ---------- 10. liquid wipe when the colour changes ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-bb-swatch]');
    if (!sw || sw.disabled || still()) return;
    var card = sw.closest('[data-bb-card]') || sw.closest('[data-bb-product]');
    var media = card && (card.querySelector('.bb-card__media') || card.querySelector('.bb-hero__product') || card.querySelector('[data-bb-pdp-main]'));
    if (!media) return;
    var dot = sw.querySelector('i');
    var colour = dot ? getComputedStyle(dot).backgroundColor : 'var(--bb-yellow)';
    var old = media.querySelector('.bb-wipe');
    if (old) old.remove();
    var w = document.createElement('span');
    w.className = 'bb-wipe';
    w.innerHTML = '<span class="bb-wipe__fill"></span>';
    w.style.setProperty('--bb-wipe-colour', colour);
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.appendChild(w);
    requestAnimationFrame(function () { w.classList.add('is-running'); });
    setTimeout(function () { w.remove(); }, 900);
  }, true);

  /* the pinned frame needs to clear the sticky header, whatever height it is */
  (function () {
    var header = $('[data-bb-header]') || $('.bb-header');
    if (!header) return;
    function measure() {
      var h = Math.round(header.getBoundingClientRect().height) || 72;
      document.documentElement.style.setProperty('--bb-header-h', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  })();

  /* ---------- 11. pinned scroll sequence ---------- */
  $$('[data-bb-seq]').forEach(function (seq) {
    var panels = $$('.bb-seq__panel', seq);
    var shots = $$('.bb-seq__media img', seq);
    var dots = $$('.bb-seq__dot', seq);
    if (!panels.length) return;
    /* svh can misreport inside a scaled or embedded frame, so set the pin
       height from the real viewport and keep it in step with resizes. */
    var span = parseFloat(seq.getAttribute('data-span')) || 1;
    function sizePin() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (vh > 200) seq.style.minHeight = Math.round(vh * span) + 'px';
    }
    sizePin();
    window.addEventListener('resize', sizePin);
    window.addEventListener('orientationchange', sizePin);

    var media = $('.bb-seq__media', seq);
    var lastImg = null;
    function shapeTo(img) {
      /* Size the frame to the largest box that fits the space AND keeps the
         photo's own shape — so nothing is cropped off the sides and nothing
         is left letterboxed at the top. */
      if (!media || !img || !img.naturalWidth) return;
      lastImg = img;
      var cell = media.closest('.bb-seq__mediacell') || media.parentNode;
      if (!cell) return;
      var availW = cell.clientWidth;
      var availH = cell.clientHeight;
      if (!availW || !availH) {           /* not laid out yet — try again next frame */
        requestAnimationFrame(function () { shapeTo(img); });
        return;
      }
      var ar = clamp(img.naturalWidth / img.naturalHeight, 0.62, 1.9);
      var w = Math.min(availW, availH * ar);
      media.style.aspectRatio = String(ar.toFixed(3));
      media.style.width = Math.round(w) + 'px';
    }
    window.addEventListener('resize', function () { shapeTo(lastImg); });
    function activate(i) {
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      panels.forEach(function (p, n) { if (n === i) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true'); });
      shots.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      var shot = shots[i];
      if (shot) {
        if (shot.complete && shot.naturalWidth) shapeTo(shot);
        else shot.addEventListener('load', function () { shapeTo(shot); }, { once: true });
      }
      dots.forEach(function (d, n) {
        d.setAttribute('aria-current', String(n === i));
        d.setAttribute('aria-selected', String(n === i));
        d.classList.toggle('is-done', n < i);
      });
    }
    if (still()) { seq.classList.add('is-static'); panels.forEach(function (p) { p.classList.add('is-active'); }); return; }
    activate(0);
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var r = seq.getBoundingClientRect();
        var total = seq.offsetHeight - window.innerHeight;
        /* land in the middle of the step, so it is unmistakably the one showing */
        var target = window.scrollY + r.top + (total * ((i + 0.45) / panels.length));
        window.scrollTo({ top: target, behavior: 'smooth' });
      });
    });
    scrollJobs.push(function () {
      var r = seq.getBoundingClientRect();
      var total = seq.offsetHeight - window.innerHeight;
      if (total <= 0) return;
      var p = clamp(-r.top / total, 0, 0.9999);
      activate(Math.floor(p * panels.length));
    });
  });

  /* ---------- 12. lightbox ---------- */
  (function () {
    var groups = $$('[data-bb-lightbox]');
    if (!groups.length) return;
    var box, imgEl, countEl, items = [], idx = 0, lastFocus = null;

    function build() {
      box = document.createElement('div');
      box.className = 'bb-lightbox';
      box.setAttribute('data-open', 'false');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML =
        '<div class="bb-lightbox__inner"><img alt=""></div>' +
        '<button type="button" class="bb-iconbtn bb-lightbox__close" data-lb-close aria-label="Close">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        '<button type="button" class="bb-iconbtn bb-lightbox__nav bb-lightbox__nav--prev" data-lb-prev aria-label="Previous">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m14 6-6 6 6 6"/></svg></button>' +
        '<button type="button" class="bb-iconbtn bb-lightbox__nav bb-lightbox__nav--next" data-lb-next aria-label="Next">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m10 6 6 6-6 6"/></svg></button>' +
        '<span class="bb-lightbox__count"></span>';
      document.body.appendChild(box);
      imgEl = $('img', box);
      countEl = $('.bb-lightbox__count', box);
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]') || e.target === box) return close();
        if (e.target.closest('[data-lb-prev]')) return show(idx - 1);
        if (e.target.closest('[data-lb-next]')) return show(idx + 1);
      });
    }
    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      imgEl.src = it.src;
      imgEl.alt = it.alt || '';
      countEl.textContent = (idx + 1) + ' / ' + items.length;
    }
    function open(list, i, trigger) {
      if (!box) build();
      items = list; lastFocus = trigger;
      show(i);
      box.setAttribute('data-open', 'true');
      document.body.classList.add('bb-no-scroll');
      $('[data-lb-close]', box).focus();
    }
    function close() {
      box.setAttribute('data-open', 'false');
      document.body.classList.remove('bb-no-scroll');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.addEventListener('keydown', function (e) {
      if (!box || box.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    groups.forEach(function (group) {
      var triggers = $$('[data-bb-lb-item]', group);
      triggers.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          var list = triggers.map(function (x) {
            var im = x.querySelector('img');
            return { src: x.getAttribute('data-full') || (im && im.currentSrc) || (im && im.src), alt: im ? im.alt : '' };
          });
          open(list, i, t);
        });
      });
    });
  })();

  /* ---------- 13. product anatomy pins ---------- */
  $$('[data-bb-anatomy]').forEach(function (root) {
    var pins = $$('.bb-anatomy__pin', root);
    var legend = $$('.bb-anatomy__legend button', root);
    function focusPin(i) {
      pins.forEach(function (p, n) { p.classList.toggle('is-open', n === i); });
      legend.forEach(function (b, n) { b.setAttribute('aria-current', String(n === i)); });
    }
    legend.forEach(function (b, i) {
      b.addEventListener('click', function () { focusPin(i); });
      on(b, 'pointerenter', function () { focusPin(i); });
    });
    pins.forEach(function (p, i) {
      var dot = $('.bb-anatomy__dot', p);
      if (dot) dot.addEventListener('click', function () { focusPin(i); });
    });
  });

  /* ---------- 12b. hero Bloks: name on tap, colour follows the cards ---------- */
  (function () {
    var stage = $('[data-bb-cubes]');
    if (!stage) return;
    var cubes = $$('[data-bb-cube]', stage);

    cubes.forEach(function (c) {
      c.addEventListener('click', function () {
        cubes.forEach(function (x) { x.classList.toggle('is-named', x === c); });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-bb-cubes]')) cubes.forEach(function (x) { x.classList.remove('is-named'); });
    });

    /* whichever colour the visitor picks in the shop panel, the Bloks follow */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-bb-swatch]');
      if (!sw || sw.disabled) return;
      var value = (sw.getAttribute('data-colour-value') || '').toLowerCase();
      var key = value.indexOf('green') > -1 ? 'green' : 'yellow';
      cubes.forEach(function (c, i) {
        var src = c.getAttribute('data-' + key);
        var img = $('[data-bb-cube-img]', c);
        if (!src || !img || img.getAttribute('src') === src) return;
        if (still()) { img.src = src; return; }
        setTimeout(function () {
          img.classList.add('is-swapping');
          var pre = new Image();
          pre.onload = pre.onerror = function () {
            img.src = src;
            requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
          };
          pre.src = src;
        }, i * 60);
      });
    }, true);
  })();

  /* ---------- 12b-i. accent follows the colour the visitor picked ----------
     Every control reads --bb-accent. Setting data-bb-accent on a section
     retints its buttons, ticks, dots and borders in one go. */
  (function () {
    function colourOf(el) {
      var v = (el.getAttribute('data-colour-value') || el.getAttribute('data-colour') || '').toLowerCase();
      return v.indexOf('green') > -1 ? 'green' : 'yellow';
    }
    function paint(scope, key) {
      if (!scope) return;
      scope.setAttribute('data-bb-accent', key);
    }
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-bb-swatch],[data-bb-anatomy-colour]');
      if (!sw || sw.disabled) return;
      var key = colourOf(sw);
      /* nearest thing that owns a colour choice: the card, the product, or the section */
      var scope = sw.closest('[data-bb-card],[data-bb-product],.shopify-section,section');
      paint(scope, key);
      /* sections that mirror the choice without carrying a swatch of their own */
      $$('[data-bb-accent-follow]').forEach(function (el) { paint(el, key); });
    }, true);

    /* start from whatever is already selected on the page */
    $$('[data-bb-swatch][aria-pressed="true"]').forEach(function (sw) {
      paint(sw.closest('[data-bb-card],[data-bb-product],.shopify-section,section'), colourOf(sw));
    });
  })();

  /* ---------- 12b-ii. scene strip: drag to scroll, colour follows the shop ---------- */
  $$('[data-bb-scenes]').forEach(function (rail) {
    var down = false, startX = 0, startLeft = 0, moved = 0;

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;          /* native touch scroll is better */
      down = true; moved = 0;
      startX = e.clientX; startLeft = rail.scrollLeft;
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = Math.abs(dx); rail.classList.add('is-dragging'); }
      rail.scrollLeft = startLeft - dx;
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      rail.addEventListener(ev, function () { down = false; rail.classList.remove('is-dragging'); });
    });
    rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);

    rail.addEventListener('keydown', function (e) {
      var step = rail.clientWidth * 0.7;
      if (e.key === 'ArrowRight') { e.preventDefault(); rail.scrollBy({ left: step, behavior: still() ? 'auto' : 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); rail.scrollBy({ left: -step, behavior: still() ? 'auto' : 'smooth' }); }
    });

    /* whichever colour the visitor picks in the shop panel, the photos follow */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-bb-swatch]');
      if (!sw || sw.disabled) return;
      var key = (sw.getAttribute('data-colour-value') || '').toLowerCase().indexOf('green') > -1 ? 'green' : 'yellow';
      $$('.bb-scene', rail).forEach(function (fig, i) {
        var src = fig.getAttribute('data-' + key);
        var img = $('.bb-scene__img', fig);
        if (!src || !img || img.getAttribute('src') === src) return;
        if (still()) { img.src = src; img.removeAttribute('srcset'); return; }
        setTimeout(function () {
          img.classList.add('is-swapping');
          var pre = new Image();
          pre.onload = pre.onerror = function () {
            img.src = src; img.removeAttribute('srcset');
            requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
          };
          pre.src = src;
        }, i * 55);
      });
    }, true);
  });

  /* ---------- 12c. expandable feature chips ---------- */
  $$('[data-bb-usps]').forEach(function (root) {
    var chips = $$('[data-bb-usp]', root);
    chips.forEach(function (chip) {
      var panelId = chip.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) { chip.setAttribute('aria-expanded', 'false'); chip.removeAttribute('aria-controls'); return; }
      chip.addEventListener('click', function () {
        var open = chip.getAttribute('aria-expanded') === 'true';
        chips.forEach(function (c) {
          c.setAttribute('aria-expanded', 'false');
          var pid = c.getAttribute('aria-controls');
          var p = pid ? document.getElementById(pid) : null;
          if (p) p.hidden = true;
        });
        if (!open) { chip.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
      });
    });
  });

  /* ---------- 13b. anatomy colour toggle ---------- */
  $$('[data-bb-anatomy]').forEach(function (root) {
    var btns = $$('[data-bb-anatomy-colour]', root);
    var img = $('[data-bb-anatomy-img]', root);
    if (!btns.length || !img) return;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        if (!src) return;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (still()) { img.src = src; return; }
        img.classList.add('is-swapping');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          img.src = src;
          requestAnimationFrame(function () { img.classList.remove('is-swapping'); });
        };
        pre.src = src;
      });
    });
  });

  /* ---------- 14. suitcase packs itself on scroll ---------- */
  $$('[data-bb-pack]').forEach(function (el) {
    if (still()) { el.style.setProperty('--bb-packed', 1); return; }
    scrollJobs.push(function (y, vh) {
      var r = el.getBoundingClientRect();
      var p = clamp(1 - (r.top - vh * 0.25) / (vh * 0.6), 0, 1);
      el.style.setProperty('--bb-packed', p.toFixed(3));
    });
  });

  /* ---------- 15. zip draws itself ---------- */
  $$('[data-bb-zip]').forEach(function (el) {
    var path = $('[data-bb-zip-path]', el);
    if (!path) return;
    var len = 400;
    try { len = path.getTotalLength(); } catch (err) { }
    path.style.strokeDasharray = '7 9';
    if (still()) { path.style.strokeDashoffset = 0; return; }
    scrollJobs.push(function (y, vh) {
      var r = el.getBoundingClientRect();
      var p = clamp(1 - (r.top - vh * 0.3) / (vh * 0.5), 0, 1);
      path.style.strokeDashoffset = String(len * (1 - p));
    });
  });

  /* 16. The first packing game was superseded by "16b. pack a bag" below.
     Nothing rendered its markup any more, so its code has been removed. */

  /* ---------- 16b. pack a bag (backpack or carry-on) ---------- */
  $$('[data-bb-pack2]').forEach(function (root) {
    var items = $$('[data-bb-pack-item]', root);
    var stage = $('[data-bb-pack-drop]', root);
    var slots = $('[data-bb-pack-slots]', root);
    var fill = $('[data-bb-pack-fill]', root);
    var status = $('[data-bb-pack-status]', root);
    var shape = $('[data-bb-pack-shape]', root);
    var modes = $$('[data-bb-pack-mode]', root);
    var combos = $$('[data-bb-pack-combo]', root);
    var compressBtn = $('[data-bb-pack-compress]', root);
    var reset = $('[data-bb-pack-reset]', root);
    if (!stage || !slots) return;

    var SHAPES = {
      backpack: '<svg viewBox="0 0 260 300" aria-hidden="true"><path d="M40 96a90 90 0 0 1 180 0v158a30 30 0 0 1-30 30H70a30 30 0 0 1-30-30Z" fill="none" stroke="currentColor" stroke-width="6"/><path d="M92 96V70a38 38 0 0 1 76 0v26" fill="none" stroke="currentColor" stroke-width="6"/><rect x="76" y="186" width="108" height="62" rx="18" fill="none" stroke="currentColor" stroke-width="6"/><path d="M40 130c-16 8-22 26-18 46M220 130c16 8 22 26 18 46" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round"/></svg>',
      suitcase: '<svg viewBox="0 0 340 240" aria-hidden="true"><rect x="8" y="34" width="152" height="196" rx="22" fill="none" stroke="currentColor" stroke-width="6"/><rect x="180" y="34" width="152" height="196" rx="22" fill="none" stroke="currentColor" stroke-width="6"/><path d="M160 34v196M96 34V12h150v22" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><circle cx="46" cy="236" r="8" fill="none" stroke="currentColor" stroke-width="6"/><circle cx="292" cy="236" r="8" fill="none" stroke="currentColor" stroke-width="6"/></svg>'
    };

    var mode = modes[0];
    var compressed = false;
    var used = 0;

    function cap() {
      if (!mode) return 6;
      return Number(mode.getAttribute(compressed ? 'data-capacity-compressed' : 'data-capacity')) || 6;
    }
    function say(text, state) {
      if (!status) return;
      status.textContent = text || '';
      status.setAttribute('data-state', state || '');
    }
    var gauge = $('[data-bb-pack-gauge]', root);
    var usedEl = $('[data-bb-pack-used]', root);
    var capEl = $('[data-bb-pack-cap]', root);
    var lastPct = -1;
    function update() {
      var total = cap();
      var pct = Math.min(100, Math.round((used / total) * 100));
      if (fill) {
        var track = fill.parentNode;
        track.style.setProperty('--bb-fill', pct);
        fill.setAttribute('data-over', String(used > total));
        fill.setAttribute('data-level', pct >= 100 ? 'full' : pct >= 60 ? 'mid' : 'low');
        if (pct !== lastPct && lastPct !== -1 && !still()) {
          track.classList.remove('is-bumped'); void track.offsetWidth; track.classList.add('is-bumped');
        }
        lastPct = pct;
      }
      /* "2 / 5" reads like a count of pieces. It is not — it is abstract
         capacity — so the gauge says how full the bag is in words instead. */
      if (usedEl) {
        var band = pct === 0 ? 'empty' : pct < 40 ? 'roomy' : pct < 75 ? 'half' : pct < 100 ? 'nearly' : 'full';
        var words = {
          empty:  root.getAttribute('data-cap-empty')  || 'Empty',
          roomy:  root.getAttribute('data-cap-roomy')  || 'Plenty of room left',
          half:   root.getAttribute('data-cap-half')   || 'About half full',
          nearly: root.getAttribute('data-cap-nearly') || 'Nearly full',
          full:   root.getAttribute('data-cap-full')   || 'Full'
        };
        usedEl.textContent = used > total ? (root.getAttribute('data-cap-over') || 'Over capacity') : words[band];
      }
      if (capEl) capEl.textContent = '';
      if (gauge) gauge.setAttribute('data-state', used > total ? 'over' : used >= total ? 'full' : '');
      stage.classList.toggle('has-items', used > 0);
      if (compressBtn) compressBtn.disabled = used === 0 || compressed;
      if (used === 0) say(root.getAttribute('data-msg-start'), '');
      else if (used >= cap()) say(root.getAttribute('data-msg-full'), 'full');
      else say(root.getAttribute('data-msg-fits'), '');
    }
    function nudge() {
      if (still()) return;
      stage.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(7px)' }, { transform: 'translateX(0)' }],
        { duration: 280, easing: 'ease-out' }
      );
    }
    function packOne(item, quiet) {
      if (!item || item.getAttribute('data-packed') === 'true') return false;
      var size = Number(item.getAttribute('data-size')) || 1;
      if (used + size > cap()) {
        if (!quiet) { say(root.getAttribute('data-msg-wont'), 'full'); nudge(); }
        return false;
      }
      item.setAttribute('data-packed', 'true');
      /* State must not be carried by a colour change alone: the button reports
         itself as pressed, and a tick appears next to the name. */
      item.setAttribute('aria-pressed', 'true');
      used += size;
      var src = item.querySelector('img');
      var clone = document.createElement('img');
      clone.src = src ? src.src : '';
      clone.alt = '';
      clone.width = 160; clone.height = 160;
      clone.style.width = (2 + size * 0.7) + 'rem';
      /* remember which Blok this is so a second tap can take it back out */
      clone.setAttribute('data-for', item.getAttribute('data-bb-pack-item') || '');
      slots.appendChild(clone);
      if (!quiet) update();
      return true;
    }
    /* One interaction, both ways round: tap to pack, tap the same Blok to
       unpack it. Nothing to explain and nothing to discover. */
    function unpackOne(item, quiet) {
      if (!item || item.getAttribute('data-packed') !== 'true') return false;
      var id = item.getAttribute('data-bb-pack-item') || '';
      var clone = slots.querySelector('[data-for="' + id + '"]');
      if (clone) clone.parentNode.removeChild(clone);
      item.removeAttribute('data-packed');
      item.setAttribute('aria-pressed', 'false');
      used = Math.max(0, used - (Number(item.getAttribute('data-size')) || 1));
      if (!slots.children.length) { compressed = false; slots.classList.remove('is-compressed'); }
      if (!quiet) update();
      return true;
    }
    function togglePack(item) {
      if (item && item.getAttribute('data-packed') === 'true') return unpackOne(item);
      return packOne(item);
    }
    function clearAll(quiet) {
      items.forEach(function (i) {
        i.removeAttribute('data-packed');
        i.setAttribute('aria-pressed', 'false');
      });
      slots.innerHTML = '';
      slots.classList.remove('is-compressed');
      compressed = false;
      used = 0;
      if (!quiet) update();
    }
    function setMode(m, quiet) {
      mode = m;
      modes.forEach(function (x) { x.setAttribute('aria-pressed', String(x === m)); });
      if (shape) shape.innerHTML = SHAPES[m.getAttribute('data-bb-pack-mode')] || '';
      clearAll(quiet);
    }
    function doCompress(quiet) {
      compressed = true;
      slots.classList.add('is-compressed');
      if (!quiet) { say(root.getAttribute('data-msg-done'), ''); confetti(compressBtn); }
      update();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () { togglePack(item); });
      item.addEventListener('dragstart', function (e) {
        e.dataTransfer.setData('text/plain', item.getAttribute('data-bb-pack-item'));
        e.dataTransfer.effectAllowed = 'move';
      });
    });
    stage.addEventListener('dragover', function (e) { e.preventDefault(); stage.classList.add('is-over'); });
    stage.addEventListener('dragleave', function () { stage.classList.remove('is-over'); });
    stage.addEventListener('drop', function (e) {
      e.preventDefault();
      stage.classList.remove('is-over');
      var id = e.dataTransfer.getData('text/plain');
      packOne(items.filter(function (x) { return x.getAttribute('data-bb-pack-item') === id; })[0]);
    });

    modes.forEach(function (m) { m.addEventListener('click', function () { setMode(m); }); });

    /* one-tap suggested combinations */
    combos.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wanted = (btn.getAttribute('data-bb-pack-combo') || '').split(',').map(function (x) { return x.trim().toLowerCase(); });
        var wantMode = btn.getAttribute('data-mode') || 'backpack';
        var target = modes.filter(function (m) { return m.getAttribute('data-bb-pack-mode') === wantMode; })[0] || modes[0];
        setMode(target, true);
        if (btn.getAttribute('data-compress') === 'true') doCompress(true);
        wanted.forEach(function (name) {
          /* Match on the exact key across every Blok BEFORE falling back to
             the label, and never on a bare substring. The old order made the
             loose match harmless by accident: asking for "s" matched "Extra
             Small" the moment Extra Small moved to the front of the tray, so
             the combo silently packed the wrong Blok and dropped the Small. */
          var byKey = items.filter(function (x) {
            return (x.getAttribute('data-key') || '').toLowerCase() === name;
          })[0];
          var it = byKey || items.filter(function (x) {
            var l = (x.getAttribute('data-label') || '').toLowerCase();
            return l === name || l.split('\u00b7')[0].trim() === name || l.indexOf(name + ' ') === 0;
          })[0];
          packOne(it, true);
        });
        update();
        if (compressed) say(root.getAttribute('data-msg-done'), '');
      });
    });

    if (compressBtn) compressBtn.addEventListener('click', function () { doCompress(); });
    if (reset) reset.addEventListener('click', function () { clearAll(); });

    setMode(modes[0], true);
    update();
  });

  /* ---------- 17. patch customiser ---------- */
  $$('[data-bb-custom]').forEach(function (root) {
    var opts = $$('[data-bb-custom-opt]', root);
    var stage = $('[data-bb-custom-applied]', root);
    if (!stage) return;
    var MAX = 3;
    var dots = $('[data-bb-custom-dots]', root);
    var text = $('[data-bb-custom-text]', root);
    var tpl = text ? text.textContent.replace(/\d+/, '[n]') : '';

    var chosen = function () {
      return opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; });
    };
    function render() {
      var on = chosen();
      stage.innerHTML = '';
      on.slice(0, MAX).forEach(function (o) {
        var svg = o.querySelector('svg');
        if (!svg) return;
        var w = document.createElement('span');
        w.className = 'bb-sticker';
        w.setAttribute('aria-hidden', 'true');
        var c = svg.cloneNode(true);
        c.setAttribute('width', '46'); c.setAttribute('height', '46');
        w.appendChild(c);
        stage.appendChild(w);
      });
      /* the full ones stay pressable so you can swap; the rest read as locked */
      opts.forEach(function (o) {
        var isOn = o.getAttribute('aria-pressed') === 'true';
        o.setAttribute('data-locked', String(!isOn && on.length >= MAX));
      });
      if (dots) {
        dots.innerHTML = '';
        for (var i = 0; i < MAX; i++) {
          var d = document.createElement('i');
          d.setAttribute('data-on', String(i < on.length));
          dots.appendChild(d);
        }
      }
      if (text && tpl) text.textContent = tpl.replace('[n]', String(on.length));
    }
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        var on_ = o.getAttribute('aria-pressed') === 'true';
        if (!on_ && chosen().length >= MAX) {
          /* say no with a nudge rather than nothing at all */
          o.classList.remove('is-nope'); void o.offsetWidth; o.classList.add('is-nope');
          return;
        }
        if (!on_) {
          /* send the patch across to the Blok before it appears there */
          var svg = o.querySelector('svg');
          if (svg) {
            var ghost = document.createElement('span');
            ghost.className = 'bb-sticker bb-sticker--flying';
            var c = svg.cloneNode(true);
            c.setAttribute('width', '44'); c.setAttribute('height', '44');
            ghost.appendChild(c);
            flyTo(o, stage, ghost, { endScale: 1.1, spin: 300, duration: 520 });
          }
        }
        o.setAttribute('aria-pressed', String(!on_));
        render();
      });
    });
    render();
  });

  /* ---------- 18. bag size finder ---------- */
  $$('[data-bb-finder]').forEach(function (root) {
    var opts = $$('[data-bb-finder-opt]', root);
    var out = $('[data-bb-finder-out]', root);
    if (!out) return;
    var img = $('img', out), title = $('[data-bb-finder-title]', out), body = $('[data-bb-finder-body]', out), link = $('a', out);
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
        if (img && o.getAttribute('data-image')) img.src = o.getAttribute('data-image');
        if (title) title.textContent = o.getAttribute('data-title') || '';
        if (body) body.textContent = o.getAttribute('data-body') || '';
        if (link && o.getAttribute('data-url')) { link.href = o.getAttribute('data-url'); link.hidden = false; }
        out.setAttribute('data-shown', 'true');
      });
    });
  });

  /* ---------- 18a2. photo carousel ---------- */
  $$('[data-bb-pcar]').forEach(function (root) {
    var track = $('[data-bb-pcar-track]', root);
    var slides = $$('[data-bb-pcar-slide]', root);
    var dots = $('[data-bb-pcar-dots]', root.parentNode || root);
    var prev = $('[data-bb-pcar-prev]', root);
    var next = $('[data-bb-pcar-next]', root);
    if (!track || slides.length < 2) return;
    var i = 0;

    function go(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (dots) $$('button', dots).forEach(function (d, k) {
        d.setAttribute('aria-current', String(k === i));
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      /* only the slide on screen is reachable by keyboard or screen reader */
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', String(k !== i)); });
    }

    if (dots) {
      slides.forEach(function (_, k) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'bb-pcar__dot';
        d.setAttribute('aria-label', 'Show photo ' + (k + 1) + ' of ' + slides.length);
        d.addEventListener('click', function () { go(k); });
        dots.appendChild(d);
      });
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(i + 1); e.preventDefault(); }
    });
    go(0);
  });

  /* ---------- 18b. story timeline ---------- */
  $$('[data-bb-timeline]').forEach(function (root) {
    var chips = $$('[data-bb-tl-chip]', root);
    var slides = $$('[data-bb-tl-slide]', root);
    var prog = $('[data-bb-tl-progress]', root);
    var line = prog ? prog.parentNode : null;
    var prev = $('[data-bb-tl-prev]', root);
    var next = $('[data-bb-tl-next]', root);
    var idxEl = $('[data-bb-tl-index]', root);
    var rail = $('.bb-tl__rail', root);
    if (!chips.length || !slides.length) return;

    var i = 0, timer = null;
    var auto = parseFloat(root.getAttribute('data-auto')) || 0;

    function show(n, focusChip) {
      n = Math.max(0, Math.min(chips.length - 1, n));
      i = n;
      chips.forEach(function (c, k) {
        c.setAttribute('aria-selected', String(k === n));
        c.setAttribute('tabindex', k === n ? '0' : '-1');
      });
      slides.forEach(function (sl, k) {
        if (k === n) { sl.hidden = false; sl.classList.remove('is-on'); void sl.offsetWidth; sl.classList.add('is-on'); }
        else { sl.hidden = true; sl.classList.remove('is-on'); }
      });
      if (line) line.style.setProperty('--bb-tl-pct',
        chips.length > 1 ? Math.round((n / (chips.length - 1)) * 100) : 100);
      if (idxEl) idxEl.textContent = String(n + 1);
      if (prev) prev.disabled = n === 0;
      if (next) next.disabled = n === chips.length - 1;
      var chip = chips[n];
      if (rail && chip) {
        var want = chip.offsetLeft - (rail.clientWidth - chip.offsetWidth) / 2;
        rail.scrollTo({ left: want, behavior: still() ? 'auto' : 'smooth' });
      }
      if (focusChip && chip) chip.focus();
    }

    chips.forEach(function (c, k) {
      c.addEventListener('click', function () { stop(); show(k); });
    });
    if (prev) prev.addEventListener('click', function () { stop(); show(i - 1); });
    if (next) next.addEventListener('click', function () { stop(); show(i + 1); });

    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-bb-tl-chip]')) return;
      var map = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: chips.length - 1 };
      if (!(e.key in map)) return;
      e.preventDefault(); stop(); show(map[e.key], true);
    });

    /* swipe on the panel */
    var panel = $('[data-bb-tl-panel]', root), sx = 0, sy = 0, tracking = false;
    if (panel) {
      panel.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; tracking = true;
      }, { passive: true });
      panel.addEventListener('touchend', function (e) {
        if (!tracking) return; tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.6) { stop(); show(i + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (!auto || still() || timer) return;
      timer = setInterval(function () { show(i >= chips.length - 1 ? 0 : i + 1); }, auto * 1000);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin', stop);
    root.addEventListener('mouseleave', start);

    if (auto && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { threshold: 0.35 }).observe(root);
    }

    show(0);
  });

  /* ---------- 18c. size guide: see a Blok inside the case ---------- */
  $$('[data-bb-scale]').forEach(function (rail) {
    var ghost = $('[data-bb-scale-ghost]', rail);
    var pctEl = ghost ? $('[data-bb-scale-pct]', ghost) : null;
    var items = $$('[data-bb-scale-item]', rail);
    if (!ghost || !items.length) return;
    /* The scale now lives in CSS so a phone can draw the same guide smaller.
       Measure the reference case rather than parsing the custom property: a
       property holding a calc() comes back as the unresolved string, and the
       ghost was then drawn at the desktop scale on a phone. The case is on
       screen and already drawn at whatever scale the breakpoint chose. */
    var caseEl = $('.bb-scale__case', rail);
    function scalePx() {
      if (caseEl) {
        var w = caseEl.getBoundingClientRect().width;
        var cw = parseFloat(rail.getAttribute('data-case-w'));
        if (w > 0 && cw > 0) return w / cw;
      }
      var v = parseFloat(getComputedStyle(rail).getPropertyValue('--bb-sc'));
      if (!v || isNaN(v)) v = parseFloat(rail.getAttribute('data-scale'));
      return v || 6;
    }
    var caseW = parseFloat(rail.getAttribute('data-case-w')) || 0;
    var caseH = parseFloat(rail.getAttribute('data-case-h')) || 0;
    var tpl = rail.getAttribute('data-fit-label') || '[pct]%';

    var readout = $('[data-bb-scale-readout]', rail);
    var roTitle = readout ? readout.querySelector('b') : null;
    var roNote = readout ? readout.querySelector('span') : null;
    function fitText(w, h) {
      var pct = Math.round((w * h) / (caseW * caseH) * 100);
      return tpl.replace('[pct]', String(pct));
    }
    /* On a phone the Bloks carry no measurements — the case says them, once,
       for whichever Blok is currently drawn inside it. */
    function readoutFor(item, label) {
      if (!readout) return;
      if (item) {
        /* name on top, then its measurements and how much of the case it takes.
           The dims string already carries its own size code, so the name is not
           repeated into it. */
        if (roTitle) roTitle.textContent = item.getAttribute('data-name') || '';
        if (roNote) {
          var dims = item.getAttribute('data-dims') || '';
          roNote.textContent = dims && label ? dims + ' · ' + label : (dims || label || '');
        }
        readout.classList.add('is-on');
      } else {
        if (roTitle) roTitle.textContent = readout.getAttribute('data-idle-title') || '';
        if (roNote) roNote.textContent = readout.getAttribute('data-idle-note') || '';
        readout.classList.remove('is-on');
      }
    }
    function show(item) {
      var w = parseFloat(item.getAttribute('data-w')) || 0;
      var h = parseFloat(item.getAttribute('data-h')) || 0;
      if (!w || !h || !caseW || !caseH) return;
      var px = scalePx();
      ghost.style.width = Math.min(w * px, caseW * px - 16) + 'px';
      ghost.style.height = Math.min(h * px, caseH * px - 16) + 'px';
      ghost.classList.add('is-on');
      var label = fitText(w, h);
      if (pctEl) pctEl.textContent = label;
      readoutFor(item, label);
      items.forEach(function (x) { x.classList.toggle('is-lit', x === item); });
    }
    function hide() {
      ghost.classList.remove('is-on');
      readoutFor(null);
      items.forEach(function (x) { x.classList.remove('is-lit'); });
    }
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { show(item); });
      item.addEventListener('focus', function () { show(item); });
      item.addEventListener('click', function () { show(item); });
      item.addEventListener('blur', hide);
    });
    rail.addEventListener('mouseleave', hide);
  });

  /* ---------- 18d. page tabs: show one section at a time ---------- */
  function bbOutermost(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    var top = el;
    while (top.parentElement && top.parentElement !== document.body &&
           !/^shopify-section-/.test(top.id || '')) {
      if (/^shopify-section-/.test(top.parentElement.id || '')) { top = top.parentElement; break; }
      top = top.parentElement;
    }
    return top;
  }

  $$('[data-bb-tabs]').forEach(function (bar) {
    /* A tab whose Page now exists is a link, not a panel opener. Its section is
       still on this page for anyone with scripting off, so hide it here — the
       real thing is one navigation away and showing both would say it twice. */
    /* A target can now name more than one section, comma separated, so nine
       equal pills can become four honest categories without any section being
       moved or deleted. Everything below treats a tab as a group of panels. */
    function groupOf(attr) {
      return String(attr || '').split(',').map(function (id) {
        return bbOutermost(id.trim());
      }).filter(Boolean);
    }

    $$('[data-bb-tabhide]', bar).forEach(function (a) {
      groupOf(a.getAttribute('data-bb-tabhide')).forEach(function (p) {
        p.hidden = true; p.setAttribute('data-bb-tabpanel', '');
      });
    });

    var tabs = $$('[data-bb-tab]', bar);
    if (!tabs.length) return;

    /* find the outermost wrapper for each target so the whole section hides */
    var panels = tabs.map(function (t) {
      return groupOf(t.getAttribute('data-bb-tab'));
    });
    if (!panels.some(function (g) { return g.length; })) return;

    panels.forEach(function (g) {
      g.forEach(function (p) { p.setAttribute('data-bb-tabpanel', ''); });
    });

    if (bar.getAttribute('data-sticky') === 'true') bar.setAttribute('data-stuck', 'true');

    function show(i, focusTab, keepScroll, quiet) {
      tabs.forEach(function (t, n) {
        t.setAttribute('aria-selected', String(n === i));
        t.setAttribute('tabindex', n === i ? '0' : '-1');
      });
      panels.forEach(function (g, n) {
        g.forEach(function (p) {
          if (n === i) {
            p.hidden = false;
            p.classList.remove('is-on'); void p.offsetWidth; p.classList.add('is-on');
          } else {
            p.hidden = true; p.classList.remove('is-on');
          }
        });
      });
      if (!keepScroll) {
        var y = bar.getBoundingClientRect().top + window.scrollY - 8;
        if (window.scrollY > y) window.scrollTo({ top: y, behavior: still() ? 'auto' : 'smooth' });
      }
      if (focusTab) tabs[i].focus();
      /* Only stamp the address bar on a real interaction. Doing it on load moves
         the browser's sequential-focus start point past the skip link. */
      if (!quiet) {
        var firstId = String(tabs[i].getAttribute('data-bb-tab') || '').split(',')[0].trim();
        try { history.replaceState(null, '', '#' + firstId); } catch (e) {}
      }
    }

    function closeAll() {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); t.setAttribute('tabindex', '0'); });
      panels.forEach(function (g) { g.forEach(function (p) { p.hidden = true; p.classList.remove('is-on'); }); });
    }

    /* On a landing page that starts closed, tapping the open tab folds it away
       again. On a content page something is always open, so a second tap is a
       no-op rather than a surprise. */
    var collapsible = bar.getAttribute('data-start-closed') === 'true';
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (collapsible && t.getAttribute('aria-selected') === 'true') { closeAll(); return; }
        show(i);
      });
    });

    bar.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var to = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1
             : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
      if (to === null) return;
      e.preventDefault();
      show((to + tabs.length) % tabs.length, true);
    });

    var targets = function () {
      return tabs.map(function (t) { return String(t.getAttribute('data-bb-tab') || '').split(',')[0].trim(); });
    };

    /* Any link on this page that points at a tab's anchor opens that tab —
       including "/#quiz" style links from the signposts, which is how the
       home page keeps working before the merchant has made any Pages. */
    function openByHash(hash, scroll) {
      var want = (hash || '').replace(/^#/, '');
      if (!want) return false;
      /* Match any section a tab covers, not just the first. A grouped tab like
         "The Bloks" still answers to #sizes and #patches, so every link that
         worked before the grouping still works after it. */
      var idx = -1;
      tabs.forEach(function (t, n) {
        if (idx > -1) return;
        var ids = String(t.getAttribute('data-bb-tab') || '').split(',').map(function (x) { return x.trim(); });
        if (ids.indexOf(want) > -1) idx = n;
      });
      if (idx < 0) return false;
      show(idx, false, !scroll);
      return true;
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('#') < 0) return;
      var parts = href.split('#');
      var path = parts[0];
      /* same page? empty, "/", or this exact path */
      var here = location.pathname.replace(/\/$/, '');
      var there = path.replace(/\/$/, '');
      if (there !== '' && there !== here) return;
      if (openByHash(parts[1], true)) e.preventDefault();
    });
    window.addEventListener('hashchange', function () { openByHash(location.hash, true); });

    var start = targets().indexOf((location.hash || '').slice(1));
    if (start > -1) {
      show(start, false, true, true);
    } else if (bar.getAttribute('data-start-closed') === 'true') {
      /* a landing page stays short: every panel closed until someone taps */
      closeAll();
    } else {
      show(0, false, true, true);
    }
  });

  /* ---------- 18e. which spread quiz ---------- */
  $$('[data-bb-quiz]').forEach(function (quiz) {
    var qs = $$('[data-bb-quiz-q]', quiz);
    var out = $('[data-bb-quiz-out]', quiz);
    var cards = $$('[data-bb-quiz-result]', quiz);
    var bar = $('[data-bb-quiz-bar]', quiz);
    var stepEl = $('[data-bb-quiz-step]', quiz);
    var back = $('[data-bb-quiz-back]', quiz);
    var restart = $('[data-bb-quiz-restart]', quiz);
    if (!qs.length || !out) return;

    var picks = [];          /* one score per answered question */
    var at = 0;

    function paint() {
      qs.forEach(function (q, i) {
        q.hidden = i !== at || at >= qs.length;
        if (i === at) { q.classList.remove('is-on'); void q.offsetWidth; q.classList.add('is-on'); }
      });
      var done = Math.min(at, qs.length);
      if (bar) bar.style.width = Math.round((done / qs.length) * 100) + '%';
      if (stepEl) stepEl.textContent = String(Math.min(at + 1, qs.length));
      if (back) back.disabled = at === 0;
      if (restart) restart.hidden = at < qs.length;
      var finished = at >= qs.length;
      out.hidden = !finished;
      $$('.bb-quiz__count', quiz).forEach(function (c) { c.hidden = finished; });
      if (finished) {
        var total = picks.reduce(function (a, b) { return a + b; }, 0);
        /* the highest threshold the score clears wins */
        var best = null, bestMin = -1;
        cards.forEach(function (c) {
          var min = Number(c.getAttribute('data-min')) || 0;
          if (total >= min && min >= bestMin) { best = c; bestMin = min; }
        });
        if (!best) best = cards[0];
        cards.forEach(function (c) { c.hidden = c !== best; });
      }
    }

    qs.forEach(function (q, i) {
      $$('[data-bb-quiz-opt]', q).forEach(function (opt) {
        opt.setAttribute('aria-pressed', 'false');
        opt.addEventListener('click', function () {
          $$('[data-bb-quiz-opt]', q).forEach(function (o) { o.setAttribute('aria-pressed', String(o === opt)); });
          picks[i] = Number(opt.getAttribute('data-score')) || 0;
          at = i + 1;
          paint();
          if (at >= qs.length && !still()) confetti(opt);
        });
      });
    });

    if (back) back.addEventListener('click', function () { if (at > 0) { at--; paint(); } });
    if (restart) restart.addEventListener('click', function () {
      picks = []; at = 0;
      $$('[data-bb-quiz-opt]', quiz).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      paint();
      quiz.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'center' });
    });

    paint();
  });

  /* ---------- 19. sticky sub-nav ---------- */
  $$('[data-bb-subnav]').forEach(function (nav) {
    var links = $$('a[href^="#"]', nav);
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    scrollJobs.push(function (y, vh) {
      nav.setAttribute('data-shown', String(y > vh * 0.6));
      var best = -1;
      targets.forEach(function (t, i) {
        if (!t) return;
        if (t.getBoundingClientRect().top <= vh * 0.35) best = i;
      });
      links.forEach(function (a, i) { a.setAttribute('aria-current', String(i === best)); });
    });
  });

  /* ---------- 20. free shipping progress in the bag ---------- */
  (function () {
    var bar = $('[data-bb-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold || threshold <= 0) { bar.hidden = true; return; }
    var fill = $('.bb-ship-bar__fill', bar);
    var label = $('[data-bb-ship-label]', bar);
    var totalEl = $('[data-bb-cart-total]');
    function update() {
      var cart = (window.Butterblok && window.Butterblok.Cart && window.Butterblok.Cart.state) || null;
      var total = cart ? cart.total_price : 0;
      var pct = clamp((total / threshold) * 100, 0, 100);
      if (fill) fill.parentNode.parentNode.style.setProperty('--bb-ship', pct.toFixed(1));
      var done = total >= threshold;
      bar.setAttribute('data-complete', String(done));
      if (label) {
        label.textContent = done
          ? (bar.getAttribute('data-msg-done') || '')
          : (bar.getAttribute('data-msg-away') || '').replace('[amount]', (window.Butterblok.money || String)(threshold - total));
      }
    }
    if (totalEl && 'MutationObserver' in window) {
      new MutationObserver(update).observe(totalEl, { childList: true, characterData: true, subtree: true });
    }
    setTimeout(update, 400);
  })();

  /* ---------- 21. page transition wipe ----------
     This is the yellow panel that slides up over the page before a link is
     followed. It is decoration, and decoration is never allowed to strand
     anyone on a blank screen, so it now has four ways out:

       1. It does not run on a phone at all. A tap that waits 460ms before
          anything happens feels broken on a phone even when it works, and a
          phone is where a stuck screen costs a sale.
       2. It does not run on a metered or slow connection, where the wait
          between covering the screen and the next page arriving is longest.
       3. pageshow clears it. Pressing Back restores the whole document from
          the browser's cache — veil included, still covering everything.
          THAT was the yellow screen people were getting stuck on: nothing in
          the old code ever ran again after a restore.
       4. A hard timeout clears it. If the next page has not arrived in two and
          a half seconds the veil comes off and you are looking at a working
          page again, whatever went wrong.                                   */
  (function () {
    if (still() || !allow('pageWipe')) return;
    if (window.matchMedia('(max-width: 899px)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData || /2g|slow/.test(conn.effectiveType || ''))) return;

    var veil = document.createElement('div');
    veil.className = 'bb-wipe-page';
    veil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(veil);

    var escapeTimer = null;
    function clearVeil() {
      clearTimeout(escapeTimer);
      escapeTimer = null;
      veil.classList.remove('is-in');
      veil.classList.remove('is-out');
      veil.style.transform = '';
    }

    /* Fires on a normal load AND on a back/forward restore, which is the case
       the old code never handled. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { clearVeil(); return; }
      if (performance.getEntriesByType) {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.type === 'navigate') {
          veil.classList.add('is-out');
          setTimeout(function () { veil.classList.remove('is-out'); }, 700);
          return;
        }
      }
      clearVeil();
    });
    /* Safari can restore without a useful pageshow in some versions; coming
       back to a visible tab with the veil still on is always wrong. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && veil.classList.contains('is-in')) clearVeil();
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var url = a.getAttribute('href');
      if (!url || url.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      if (/^(mailto:|tel:)/.test(url)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      /* A link like "/#how" points at THIS page. The browser only moves the
         scroll position, so no new document ever arrives — and the wipe would
         cover the screen forever waiting for one. Let those through untouched. */
      var here = location.pathname.replace(/\/$/, '');
      var there = (a.pathname || '').replace(/\/$/, '');
      if (there === here) return;
      e.preventDefault();
      veil.classList.remove('is-out');
      veil.classList.add('is-in');
      escapeTimer = setTimeout(clearVeil, 2500);
      setTimeout(function () { window.location.href = a.href; }, 460);
    });
  })();

  /* ---------- 22. easter egg: five taps on the logo ---------- */
  (function () {
    if (!allow('easterEgg')) return;
    var logo = $('.bb-header .bb-logo');
    if (!logo) return;
    var hits = 0, timer;
    logo.addEventListener('click', function (e) {
      hits++;
      clearTimeout(timer);
      timer = setTimeout(function () { hits = 0; }, 900);
      if (hits >= 5) {
        e.preventDefault();
        hits = 0;
        for (var i = 0; i < 4; i++) setTimeout(function () { confetti(logo); }, i * 220);
        if (window.Butterblok && window.Butterblok.toast) {
          window.Butterblok.toast(document.documentElement.getAttribute('data-bb-egg') || 'Pack happy.');
        }
      }
    });
  })();

  onScroll();
})();
